import { useEffect } from "react";
import NProgress from "nprogress";
import {
  CalendarPageSkeleton,
  DashboardCardsSkeleton,
  GenericCenteredSkeleton,
  ListPageSkeleton,
  ReservationCardsSkeleton,
} from "components/skeletons/PageSkeletons";

const LoadingScreen = () => {
  useEffect(() => {
    NProgress.configure({
      showSpinner: false,
    });

    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  const pathname = window.location.pathname;

  if (
    pathname.includes("/main/schedule") ||
    pathname.includes("/customer-access/schedule")
  ) {
    return <CalendarPageSkeleton />;
  }

  if (pathname.includes("/contact") || pathname.includes("/administration")) {
    return <ListPageSkeleton />;
  }

  if (pathname.includes("/customer-access/reservations")) {
    return <ReservationCardsSkeleton />;
  }

  if (pathname === "/main" || pathname === "/main/") {
    return <DashboardCardsSkeleton />;
  }

  return <GenericCenteredSkeleton />;
};

export default LoadingScreen;
